import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'
import * as dimensionFilter from '../../../../../../shared/dimension-filter'

/**
 * Organization filter for the unassigned sponsored people.
 */
@ngCore.Component({
  imports: [
    dimensionFilter.Component,
    ds.button.Component,
    ds.overlay.slideout.Component,
  ],
  selector: 'atn-space-unassigned-sponsored-people-filters',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.unassignedSponsoredPeople.Collection} */
  public readonly unassignedSponsoredPeopleEc = ngCore.inject(
    state.space.full.unassignedSponsoredPeople.Collection,
  )

  /** Current List plugin that owns the edited filters. */
  public readonly currentListPlugin =
    this.unassignedSponsoredPeopleEc.plugins.currentListPlugin

  /** Organization dimension-filter plugin owned by the collection. */
  public readonly organizationDimensionFilterPlugin =
    this.unassignedSponsoredPeopleEc.plugins
      .lookup(
        state.space.full.unassignedSponsoredPeople.plugins
          .organizationDimensionFilter.Plugin,
      )
      .get()

  /** Applies the Current List draft parameters and closes the slideout. */
  public applyClickHandler(): void {
    this.currentListPlugin.feature.actions.applyParams
      .from('Space.UnassignedSponsoredPeople.Filters.Apply.Clicked')
      .dispatch()
  }

  /** Discards the Current List draft parameters and closes the slideout. */
  public cancelClickHandler(): void {
    this.currentListPlugin.feature.actions.discardParams
      .from('Space.UnassignedSponsoredPeople.Filters.Cancel.Clicked')
      .dispatch()
  }

  /** Clears the Current List draft filters without closing the slideout. */
  public resetClickHandler(): void {
    this.currentListPlugin.editedParams.actions.setFilters
      .from('Space.UnassignedSponsoredPeople.Filters.Reset.Clicked')
      .dispatch({})
  }
}
